import React, { useContext, useState } from "react";
import Switch from "react-switch";
import { useLocation } from "react-router-dom";

//internal import
import { SidebarContext } from "context/SidebarContext";
import CustomerServices from "services/CustomerServices";
import VendorServices from "services/VendorServices";
import VehicleServices from "services/VehicleServices";
import DriverServices from "services/DriverServices";
import AgentsServices from "services/AgentsServices";
import ConfirmActiveModal from "components/form/ConfirmActiveModal";
import AdminServices from "services/AdminServices";
import HourRentalBasicRateServices from "services/HourRentalBasicRateServices";
import AirportPickupBasicRateServices from "services/AirportPickupBasicRateServices";
import DayRentalBasicRateServices from "services/DayRentalBasicRateServices";
import FixedItineraryServices from "services/FixedItineraryServices";
import TollServices from "services/TollServices";
import { notifyError, notifySuccess } from "utils/toast";
import OnewayPickupBasicRateServices from "services/OnewayPickupServices";
import NewsServices from "services/NewsServices";
import MinDurationServices from "services/MinDurationServices";
import {
  itineraryOverRideMarginServices,
  overRideMarginServices,
} from "services/marginServices";

const ShowHideButton = ({ id, status }) => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const { setIsUpdate, setFunctionLoading } = useContext(SidebarContext);
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [goStatus, setGoStatus] = useState();
  const handleChangeStatus = async (id) => {
    // return notifyError("CRUD operation is disabled for this option!");
    try {
      var newStatus;
      if (status === "Active") {
        newStatus = "Inactive";

        setGoStatus("Inactive");
      } else if (status === 1) {
        newStatus = 0;
        setGoStatus(0);
      } else if (status === 0) {
        newStatus = 1;
        setGoStatus(1);
      } else if (status === "Inactive") {
        newStatus = "Active";
        setGoStatus("Active");
      } else {
        newStatus = 1;
        setGoStatus(1);
      }

      if (location.pathname === "/min-duration") {
        const res = await MinDurationServices.updatedurationStatus(id, {
          is_active: newStatus,
        });

        setIsUpdate(true);
        notifySuccess(res.message);
      }

      if (location.pathname === "/b2b-news") {
        const res = await NewsServices.updateNewsStatus(id, {
          status: newStatus,
        });

        setIsUpdate(true);
        notifySuccess(res.message);
      }

      if (location.pathname === "/customers") {
        const res = await CustomerServices.updateCustomerStatus(id, {
          status: newStatus,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }

      if (location.pathname === "/vendor") {
        if (status !== undefined && status !== "") {
          setShowActiveModal(true);
        }
      }

      if (location.pathname === "/vehicle") {
        if (status !== undefined && status !== "") {
          const res = await VehicleServices.updateVehicleStatus(id, {
            status: newStatus,
          });
          setIsUpdate(true);
          notifySuccess(res.message);
        }
      }
      if (location.pathname === "/driver") {
        if (status !== undefined && status !== "") {
          const res = await DriverServices.updateDriverStatus(id, {
            status: newStatus,
          });
          setIsUpdate(true);
          notifySuccess(res.message);
        }
      }
      if (location.pathname === "/employee") {
        const res = await AdminServices.updateStaffStatus(id, {
          status: newStatus,
          id_employee: id_employee,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/basic-rate-hour") {
        const res = await HourRentalBasicRateServices.updateHourRentalStatus(
          id,
          {
            status: newStatus,
          },
        );
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/basic-rate-day") {
        const res = await DayRentalBasicRateServices.updateDayRentalStatus(id, {
          status: newStatus,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/airportPickup-basic-rate") {
        const res =
          await AirportPickupBasicRateServices.updateAirportPickupStatus(id, {
            status: newStatus,
          });
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/oneway-pickup-basicrate") {
        const res =
          await OnewayPickupBasicRateServices.updateOnewayPickupStatus(id, {
            status: newStatus,
          });
        setIsUpdate(true);
        notifySuccess(res.message);
      }

      if (location.pathname === "/basic-rate-fixed") {
        const res = await FixedItineraryServices.updatefixedItineraryStatus(
          id,
          {
            status: newStatus,
          },
        );
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/toll") {
        const res = await TollServices.updateTollStatus(id, {
          status: newStatus,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      if (location.pathname === "/agents") {
        setShowActiveModal(true);
        // setFunctionLoading(true);
        // const res = await AgentsServices.updateAgentsStatus(id, {
        //   status: newStatus,
        // });
        // setIsUpdate(true);
        // setFunctionLoading(false);
        // notifySuccess(res.message);
      }

      if (location.pathname === "/periodic-margin") {
        const res = await overRideMarginServices.toggleMarginStatus(id, {
          is_active: newStatus,
        });
        setIsUpdate(true);
        notifySuccess(res.message);
      }

      if (location.pathname === "/itinerary-periodic-margin") {
        const res = await itineraryOverRideMarginServices.toggleMarginStatus(
          id,
          {
            is_active: newStatus,
          },
        );
        setIsUpdate(true);
        notifySuccess(res.message);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };
  const handleUpdateStatus = async (remark) => {
    setShowActiveModal(false);
    setFunctionLoading(true);
    if (location.pathname === "/agents") {
      const updateData =
        goStatus === 0
          ? { status: goStatus, inactive_remark: remark }
          : { status: goStatus, active_remark: remark };

      const res = await AgentsServices.updateAgentsStatus(id, updateData);

      setIsUpdate(true);
      setFunctionLoading(false);
      notifySuccess(res.message);
    }
    if (location.pathname === "/vendor") {
      const res = await VendorServices.updateVendorStatus(id, {
        status: goStatus,
        deactive_remark: remark,
      });
      setIsUpdate(true);
      setFunctionLoading(false);
      notifySuccess(res.message);
    }
  };
  return (
    <>
      <Switch
        onChange={() => handleChangeStatus(id)}
        checked={status === "Active" || status === 1 ? true : false}
        className="react-switch md:ml-0"
        uncheckedIcon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              width: 120,
              fontSize: 14,
              color: "white",
              paddingRight: 22,
              paddingTop: 1,
            }}
          ></div>
        }
        width={30}
        height={15}
        handleDiameter={13}
        offColor="#E53E3E"
        onColor={"#2F855A"}
        maxLength={200}
        checkedIcon={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: 73,
              height: "100%",
              fontSize: 14,
              color: "white",
              paddingLeft: 20,
              paddingTop: 1,
            }}
          ></div>
        }
      />
      <ConfirmActiveModal
        isOpen={showActiveModal}
        status={status}
        onClose={() => setShowActiveModal(false)}
        onConfirm={handleUpdateStatus}
      />
    </>
  );
};

export default ShowHideButton;
